import { useState } from "react";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";

import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography
} from "@mui/material";

import EZlogo from "../assets/EZpresta-logo.png";

const CONTACT_ENDPOINT =
  process.env.REACT_APP_CONTACT_ENDPOINT ||
  "https://us-central1-photostudio-264220.cloudfunctions.net/sendContactRequestEmail";

const Contact = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(CONTACT_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          fullName,
          email,
          phone,
          message
        })
      });

      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(payload.error || payload.message || "Erreur lors de l'envoi.");
      }

      enqueueSnackbar(
        payload.message || "Votre demande a bien été envoyée. Nous vous contacterons rapidement.",
        { variant: "success" }
      );
      setFullName("");
      setEmail("");
      setPhone("");
      setMessage("");
    } catch (error) {
      const errorMessage = error?.message || "Erreur inconnue";
      enqueueSnackbar("Erreur lors de l'envoi du formulaire : " + errorMessage, {
        variant: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" bgcolor="#f5f5f5" px={2}>
      <Paper elevation={3} sx={{ padding: 4, width: "100%", maxWidth: 540 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <img src={EZlogo} alt="Ez Presta" style={{ width: "300px", marginBottom: "16px" }} />
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <ContactMailOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" align="center">
            Demande de création de compte
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
            Remplissez ce formulaire et nous reviendrons vers vous.
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Nom complet"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            fullWidth
            label="Téléphone"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Message"
            multiline
            minRows={4}
            value={message}
            onChange={e => setMessage(e.target.value)}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "ENVOYER MA DEMANDE"}
          </Button>

          <Link to="/login" style={{ textDecoration: "none" }}>
            <Button fullWidth variant="outlined">
              RETOUR À LA CONNEXION
            </Button>
          </Link>
        </Box>
      </Paper>
    </Box>
  );
};

export default Contact;
